// extracted by mini-css-extract-plugin
export var avatarContainer = "_89-0";
export var avatarTypingWave = "_89-i";
export var gray = "_89-f";
export var green = "_89-c";
export var icon = "_89-9";
export var image = "_89-1";
export var lg = "_89-6";
export var md = "_89-5";
export var presenceDot = "_89-b";
export var red = "_89-d";
export var sm = "_89-4";
export var status = "_89-a";
export var typingDot = "_89-h";
export var typingPill = "_89-g";
export var xl = "_89-7";
export var xs = "_89-3";
export var xxl = "_89-8";
export var xxs = "_89-2";
export var yellow = "_89-e";